import React from 'react';
import { Image, Text } from 'react-native-web';
import { View } from 'react-native';
import { Android, empty_state_icon, empty_state_str } from '../../../../utils/DictionaryManagementUtils';
import {
  clean_full_page_ios,
  getImageByKey,
  img_message_bar_android,
  img_scr_onboarding_03_a_and,
} from '../../../../utils/ImagesManagementUtils';
import FullPageSimulator from '../FullPageSimulator';
import { textSecondary_14_0 } from '../../AuxiliaryComponent/TextComponent/TextStyle';
import { xlateText } from '../../../../utils/Utils';
import LongLine from '../../AuxiliaryComponent/MixComponent/LongLine';

//= ========================================================================
const EmptyStateFP = ({
  globJSON,
  simPlatform,
  slideshowRefs,
}) => {
  const { empty_state } = globJSON.configurations.launch;
  const myStyles = {
    labelStyle: {
      width: 190,
      height: 40,
      alignSelf: 'center',
      marginTop: simPlatform === Android ? 30 : 120,
      textAlign: 'center',
      marginBottom: -10,
    },
    imageStyle: {
      width: 158,
      height: 90,
      alignSelf: 'center',
    },
    cleanImage: {
      marginTop: 85,
      width: 240,
      height: 33.3,
    },
  };
  return (
    <FullPageSimulator
      globJSON={globJSON}
      simPlatform={simPlatform}
      TopTitle={empty_state_str}
      cleanBackgroundImage={simPlatform === Android}
      WithImageBackground={simPlatform === Android ? img_scr_onboarding_03_a_and : clean_full_page_ios}
      hidePhoneHeadLine
      withOutPadding
      hideIcons
      withOutTopVerticalLine
      slideshowRefs={slideshowRefs}
      BackgroundColor="#fff"
    >
      {simPlatform === Android
            && (
            <View>
              <Image
                fadeDuration={0}
                style={myStyles.cleanImage}
                source={img_message_bar_android}
              />
              <LongLine globJSON={globJSON} marginBottom={4} />
            </View>
            )}

      <Text style={[textSecondary_14_0(globJSON, simPlatform), myStyles.labelStyle]}>
        {xlateText(empty_state.nothing_to_see_here)}
      </Text>
      <Image
        fadeDuration={0}
        resizeMode="contain"
        style={myStyles.imageStyle}
        source={getImageByKey(empty_state.empty_state_icon, empty_state_icon)}
      />
    </FullPageSimulator>

  );
};

export default EmptyStateFP;
